export default __webpack_public_path__ + "static/O0190-ed53d6ca8ebaa2f7f7052f96836397b3.png";